/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "common": {
        "nested": {
          "feetypes": {
            "nested": {
              "FeeplanType": {
                "values": {
                  "TYPE_DO_NOT_USE": 0,
                  "DEFAULT": 1,
                  "BLENDED": 2,
                  "COSTPLUS": 3,
                  "ADDITIONAL_FEE": 4,
                  "INTERCHANGE_PLUS": 5
                }
              },
              "TaxRateType": {
                "values": {
                  "INCLUSIVE": 0,
                  "EXCLUSIVE": 1
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.common?.nested?.feetypes?.nested?.FeeplanType && !$root.nested?.squareup?.nested?.common?.nested?.feetypes?.nested?.TaxRateType) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE FeeplanType @ squareup/common/fee_types.proto at 9:1
 */
export const FeeplanType = $root.lookupEnum('squareup.common.feetypes.FeeplanType').values;
/**
 * SOURCE TaxRateType @ squareup/common/fee_types.proto at 18:1
 */
export const TaxRateType = $root.lookupEnum('squareup.common.feetypes.TaxRateType').values;